export function communityIdentifiersEqual(a, b) {
    if (a === undefined && b === undefined)
        return true;
    if (a === undefined || b === undefined)
        return false;
    return a.communityId === b.communityId;
}
